import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";

const OrdersList = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get("https://api.taratoys.in/api/orders");
        setOrders(res.data);
        console.log(res.data)
        setFilteredOrders(res.data);
      } catch (err) {
        console.error("Error fetching orders:", err);
      }
    };

    fetchOrders();
  }, []);

  useEffect(() => {
    filterOrders();
  }, [searchTerm, statusFilter, dateRange, orders]);

  const filterOrders = () => {
    let filtered = [...orders];

    // Search by name, address, or email
    if (searchTerm.trim()) {
      filtered = filtered.filter((order) => {
        const { firstName, lastName, address, email } = order.shippingDetails;
        const fullName = `${firstName} ${lastName}`.toLowerCase();
        return (
          fullName.includes(searchTerm.toLowerCase()) ||
          address.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }

    // Filter by status
    if (statusFilter) {
      filtered = filtered.filter((order) => order.status === statusFilter);
    }

    // Filter by date range
    if (dateRange.from && dateRange.to) {
      filtered = filtered.filter((order) => {
        const orderDate = moment(order.createdAt);
        return (
          orderDate.isSameOrAfter(moment(dateRange.from)) &&
          orderDate.isSameOrBefore(moment(dateRange.to))
        );
      });
    }

    setFilteredOrders(filtered);
  };
const handleStatusChange = async (orderId, newStatus) => {
  try {
    await axios.put(`https://api.taratoys.in/api/orders/${orderId}`, { status: newStatus });

    // Update status locally
    const updated = orders.map((order) =>
      order._id === orderId ? { ...order, status: newStatus } : order
    );
    setOrders(updated);
    setFilteredOrders(updated);
  } catch (err) {
    console.error("Failed to update status:", err);
    alert("Failed to update order status");
  }
};

  return (
    <div className="container py-5">
      <h2 className="mb-4">Admin - All Orders</h2>

      {/* Filters */}
      <div className="row mb-4 g-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, email, or address"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Shipped">Shipped</option>
          </select>
        </div>

        <div className="col-md-2">
          <input
            type="date"
            className="form-control"
            value={dateRange.from}
            onChange={(e) => setDateRange({ ...dateRange, from: e.target.value })}
          />
        </div>

        <div className="col-md-2">
          <input
            type="date"
            className="form-control"
            value={dateRange.to}
            onChange={(e) => setDateRange({ ...dateRange, to: e.target.value })}
          />
        </div>

        <div className="col-md-1">
          <button className="btn btn-secondary w-100" onClick={() => {
            setSearchTerm("");
            setStatusFilter("");
            setDateRange({ from: "", to: "" });
          }}>
            Reset
          </button>
        </div>
      </div>

      {/* Orders Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Payment</th>
              <th>Date</th>
              <th>Shipping</th>
            </tr>
          </thead>
        <tbody>
  {filteredOrders.length === 0 ? (
    <tr>
      <td colSpan="8" className="text-center py-4">No orders found</td>
    </tr>
  ) : (
    filteredOrders.map((order, idx) => (
      <tr key={order._id}>
        <td>{idx + 1}</td>
        <td>{order._id.slice(-6).toUpperCase()}</td>
        <td>
          {order.shippingDetails.firstName} {order.shippingDetails.lastName}
          <br />
          <small className="text-muted">{order.shippingDetails.email}</small>
        </td>
        <td>
          <select
            className={`form-select form-select-sm ${
              order.status === 'Delivered'
                ? 'bg-success text-white'
                : order.status === 'Pending'
                ? 'bg-warning text-dark'
                : 'bg-secondary text-white'
            }`}
            value={order.status}
            onChange={(e) => handleStatusChange(order._id, e.target.value)}
          >
            <option value="Pending">Pending</option>
            <option value="Shipped">Shipped</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </td>
        <td>₹{order.finalAmount}</td>
        <td>{order.paymentMode} ({order.paymentStatus})</td>
        <td>{moment(order.createdAt).format("DD MMM YYYY")}</td>
        <td>
          {order.shippingDetails.address}<br />
          {order.shippingDetails.city}, {order.shippingDetails.state}
        </td>
      </tr>
    ))
  )}
</tbody>

        </table>
      </div>
    </div>
  );
};

export default OrdersList;


